var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('search',{attrs:{"handleOptions":_vm.handleOptions,"getData":_vm.getActivationList}}),_c('list',{attrs:{"handleOptions":_vm.handleOptions,"getData":_vm.getActivationList,"page":_vm.activationList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }